import React, { useState } from 'react';
import { useCurrency } from '../context/CurrencyContext';
import { ChevronDown } from 'lucide-react';

const CurrencySelector = ({ className = '' }) => {
  const { currency, symbol, currencies, changeCurrency } = useCurrency();
  const [open, setOpen] = useState(false);

  if (!currencies.length) return null;

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-2 py-1 text-sm font-medium text-slate-600 hover:text-emerald-600 bg-slate-100 hover:bg-emerald-50 rounded-lg transition-colors"
        data-testid="currency-selector"
      >
        {symbol} {currency}
        <ChevronDown className="w-3 h-3" />
      </button>
      
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-xl border z-50 max-h-64 overflow-y-auto w-56">
            {currencies.map((c) => (
              <button
                key={c.code}
                onClick={() => { changeCurrency(c.code); setOpen(false); }}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-emerald-50 flex items-center justify-between ${
                  c.code === currency ? 'bg-emerald-50 text-emerald-700 font-medium' : 'text-slate-700'
                }`}
              >
                <span>{c.symbol} {c.name}</span>
                <span className="text-xs text-slate-400">{c.code}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CurrencySelector;
